export enum CustomMergeFieldType {
  Text = 'Text',
  Currency = 'Currency',
}
